/* VittoriaBeauty · comportamiento de las secciones propias */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function nextMidnight() { var n = new Date(); n.setHours(24, 0, 0, 0); return n.getTime(); }

  /* Relojes: data-rx-deadline="diaria" cuenta hasta las 00:00 y se reinicia; si trae fecha, cuenta hasta esa fecha. */
  function deadline(el) {
    var raw = el.getAttribute('data-rx-deadline') || 'diaria';
    if (raw === 'diaria') return nextMidnight();
    var d = new Date(raw.trim().replace(' ', 'T'));
    return isNaN(d.getTime()) ? 0 : d.getTime();
  }
  function tick() {
    document.querySelectorAll('[data-rx-deadline]').forEach(function (el) {
      var left = deadline(el) - Date.now();
      var row = el.closest('[data-rx-timer-row]');
      if (left <= 0) { if (row) row.style.display = 'none'; return; }
      var d = Math.floor(left / 86400000);
      var h = Math.floor((left % 86400000) / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }

  /* Línea de tiempo de "detalles" y "paso a paso": avanza sola y se puede tocar. */
  function initStory(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var steps = [].slice.call(root.querySelectorAll('.rx-story__step'));
    if (!steps.length || root.classList.contains('rx-story--static')) return;
    var dur = (parseFloat(root.dataset.duration) || 7) * 1000;
    var auto = root.dataset.autoplay === 'true';
    var progressive = root.dataset.progressive === 'true';
    var i = 0, timer;
    function show(n) {
      i = n;
      steps.forEach(function (s, k) {
        s.classList.remove('is-on');
        s.style.opacity = progressive && k < n ? '1' : '';
      });
      void steps[n].offsetWidth;
      steps[n].classList.add('is-on');
      clearTimeout(timer);
      if (auto) timer = setTimeout(function () { show((i + 1) % steps.length); }, dur);
    }
    steps.forEach(function (s, k) { s.addEventListener('click', function () { show(k); }); });
    show(0);
  }

  /* Problema / solución: pestañas con barra de progreso. */
  function initSlider(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var tabs = [].slice.call(root.querySelectorAll('.rx-prob__tab'));
    var slides = [].slice.call(root.querySelectorAll('.rx-prob__slide'));
    var dur = (parseFloat(root.dataset.duration) || 8) * 1000;
    var auto = root.dataset.autoplay === 'true';
    var timer;
    function show(n) {
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-done', k < n);
        t.classList.remove('is-on');
        t.setAttribute('aria-selected', k === n ? 'true' : 'false');
      });
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === n); });
      void tabs[n].offsetWidth;
      tabs[n].classList.add('is-on');
      clearTimeout(timer);
      if (auto) timer = setTimeout(function () { show((n + 1) % slides.length); }, dur);
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    if (slides.length) show(0);
  }

  /* Así llega tu pedido: avanza solo en celular. */
  function initMedia(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    if (root.dataset.autoplay !== 'true') return;
    var track = root.querySelector('.rx-media__track');
    var dur = (parseFloat(root.dataset.duration) || 5) * 1000;
    var paused = false;
    track.addEventListener('pointerdown', function () { paused = true; });
    setInterval(function () {
      if (paused || track.scrollWidth <= track.clientWidth + 4) return;
      var card = track.querySelector('.rx-media__card');
      var step = card ? card.getBoundingClientRect().width + 12 : 200;
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      track.scrollTo({ left: end ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    }, dur);
  }

  /* Pestañas de la ficha (Descripción / Envíos / Especificaciones). */
  function initTabs(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var btns = root.querySelectorAll('.rx-tabs__btn');
    var panes = root.querySelectorAll('.rx-tabs__pane');
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.classList.toggle('is-on', j === k); x.setAttribute('aria-selected', j === k); });
        panes.forEach(function (x, j) { x.classList.toggle('is-on', j === k); });
      });
    });
  }

  /* Videos de la ficha: carrusel infinito que avanza solo y se arrastra con el dedo o el mouse.
     Los videos se reproducen en silencio solo cuando se ven; el botón activa el sonido. */
  function initVids(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var track = root.querySelector('.rx-vids__track');
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;
    // Una copia del set al final: al pasar el primer set se salta hacia atrás sin que se note.
    originals.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); track.appendChild(k); });
    var cards = track.querySelectorAll('.rx-vids__card');
    var hasIO = 'IntersectionObserver' in window;

    // Todo (descarga, reproducción y avance) corre solo mientras la sección está en pantalla.
    var onScreen = !hasIO, inTrack = [];
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function sync() {
      cards.forEach(function (c, k) {
        var v = c.querySelector('video');
        if (onScreen && inTrack[k]) play(v); else if (!v.paused) v.pause();
      });
    }
    var io = hasIO ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { inTrack[[].indexOf.call(cards, e.target)] = e.isIntersecting; });
      sync();
    }, { root: track, threshold: 0.5 }) : null;
    cards.forEach(function (c, k) { c.querySelector('video').muted = true; inTrack[k] = !hasIO; if (io) io.observe(c); });
    if (hasIO) new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      sync();
      run();
    }, { rootMargin: '200px 0px' }).observe(root);
    else sync();
    document.addEventListener('visibilitychange', run);

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('.rx-vids__sound');
      if (!btn || moved) return;
      var c = btn.closest('.rx-vids__card'), v = c.querySelector('video'), on = v.muted;
      cards.forEach(function (x) { x.querySelector('video').muted = true; x.classList.remove('is-sound'); });
      v.muted = !on;
      c.classList.toggle('is-sound', on);
      if (on) v.play();
    });

    // Ancho de un set de videos; se mide al inicio y al cambiar el tamaño, no en cada cuadro.
    var setW = 0;
    function measure() { setW = cards[originals.length].offsetLeft - cards[0].offsetLeft; }
    window.addEventListener('resize', measure, { passive: true });
    function wrap() {
      var w = setW;
      if (w <= 0) return;
      if (track.scrollLeft >= w) track.scrollLeft -= w;
      else if (track.scrollLeft <= 0) track.scrollLeft += w;
    }
    track.addEventListener('scroll', wrap, { passive: true });

    // Avance continuo; se detiene mientras la persona toca o arrastra y retoma a los 2 s.
    var speed = parseFloat(root.dataset.speed) || 30;
    var hold = false, resumeAt = 0, last = 0, pos = 0;
    function pause() { hold = true; }
    function resume() { hold = false; resumeAt = Date.now() + 2000; }
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', resume, { passive: true });
    track.addEventListener('wheel', function () { resumeAt = Date.now() + 2000; }, { passive: true });

    // Arrastre con mouse (en celular el desplazamiento es el nativo del navegador).
    var dragX = null, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragX = e.clientX; startLeft = track.scrollLeft; moved = false; pause();
      track.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (dragX === null) return;
      dragX = null; track.classList.remove('is-drag'); resume();
      setTimeout(function () { moved = false; }, 0);
    });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var raf = 0;
    function step(t) {
      raf = 0;
      var dt = last ? Math.min(t - last, 250) : 0; last = t;
      if (hold || Date.now() < resumeAt) pos = track.scrollLeft;
      else {
        var w = setW;
        pos += speed * dt / 1000;
        if (w > 0 && pos >= w) pos -= w;
        track.scrollLeft = pos;
      }
      run();
    }
    function run() {
      if (onScreen && !document.hidden) { if (!raf) raf = requestAnimationFrame(step); }
      else { if (raf) cancelAnimationFrame(raf); raf = 0; last = 0; }
    }
    measure();
    track.scrollLeft = 1;
    pos = 1;
    run();
  }

  /* Fecha de llegada: suma días hábiles (lunes a viernes) a la fecha de hoy. */
  function initShip(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    function plus(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function fmt(d, mes) { return '<b>' + dias[d.getDay()] + ' ' + d.getDate() + (mes ? ' de ' + meses[d.getMonth()] : '') + '</b>'; }
    var a = plus(parseInt(root.dataset.min, 10) || 1), z = plus(parseInt(root.dataset.max, 10) || 3);
    // El mes va una sola vez cuando las dos fechas caen en el mismo mes.
    var txt = (root.dataset.text || '')
      .replace('{desde}', fmt(a, a.getMonth() !== z.getMonth()))
      .replace('{hasta}', fmt(z, true));
    if (txt) root.querySelector('.rx-ship__tx').innerHTML = txt;
  }

  /* Packs: la tarjeta elegida define la cantidad del formulario y el texto del botón. */
  function initPacks(root) {
    if (root.dataset.rxReady) return; root.dataset.rxReady = '1';
    var formId = root.dataset.form;
    var qty = root.querySelector('input[name="quantity"]');
    function apply() {
      var input = root.querySelector('input[type="radio"]:checked');
      if (!input) return;
      root.querySelectorAll('.rx-pack').forEach(function (c) { c.classList.toggle('is-on', c.contains(input)); });
      qty.value = input.value;
      var form = document.getElementById(formId);
      var btn = form && form.querySelector('.rx-atc');
      if (btn) {
        var line = btn.querySelector('.rx-atc__price');
        if (line) line.innerHTML = input.dataset.price + (input.dataset.compare ? ' <s>' + input.dataset.compare + '</s>' : '');
      }
      document.dispatchEvent(new CustomEvent('rx:pack', { detail: { root: root, input: input } }));
    }
    root.addEventListener('change', apply);
    apply();
  }

  function initAll() {
    document.querySelectorAll('.rx-story').forEach(initStory);
    document.querySelectorAll('.rx-prob').forEach(initSlider);
    document.querySelectorAll('.rx-media').forEach(initMedia);
    document.querySelectorAll('.rx-tabs').forEach(initTabs);
    document.querySelectorAll('.rx-vids').forEach(initVids);
    document.querySelectorAll('.rx-ship').forEach(initShip);
    document.querySelectorAll('.rx-packs').forEach(initPacks);
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  setInterval(tick, 1000);
})();
